import { render, staticRenderFns } from "./createObservationTemplate.vue?vue&type=template&id=34c0d171&v-if=loaded"
import script from "./createObservationTemplate.vue?vue&type=script&lang=js"
export * from "./createObservationTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports